"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenTransactionType = void 0;
var TokenTransactionType;
(function (TokenTransactionType) {
    TokenTransactionType["OUTFIT_CONVERSION"] = "equipment_conversion";
    TokenTransactionType["OUTFIT_UPGRADE"] = "equipment_upgrade";
    TokenTransactionType["REWARD"] = "reward";
    TokenTransactionType["OUTFIT_UNLOCK"] = "equipment_unlock";
    TokenTransactionType["GW_REWARD"] = "gw_reward";
    TokenTransactionType["TRAINING_SLOT"] = "training_slot";
    TokenTransactionType["TRAINING_BOOST"] = "training_boost";
    TokenTransactionType["HALL_OF_FAME"] = "hall_of_fame";
    TokenTransactionType["PACK_PURCHASE"] = "pack_purchase";
    TokenTransactionType["FUSION_BOOST"] = "fusion_purchase";
})(TokenTransactionType || (exports.TokenTransactionType = TokenTransactionType = {}));
